'use strict';

// Turbolinks がキャッシュ（戻る・再訪時のプレビュー）から画面を描き直すときに、インラインスクリプトの CSP nonce を戻す。
// ブラウザは文書に入った script の nonce 属性を空文字に書き換えて隠す。Turbolinks 5 はキャッシュの複製から
// script を作り直すときに属性だけをコピーするため、nonce が空になり CSP 違反になる。
// 複製でも nonce プロパティには元の値が残るので、それを属性へ戻す。元々 nonce を持たない script には付けない
// （サーバーから取得した新しい画面は nonce 属性がそのまま残っているので、何もしない）。
document.addEventListener('turbolinks:before-render', function(event) {
  event.data.newBody.querySelectorAll('script').forEach(function(script) {
    if (!script.getAttribute('nonce') && script.nonce) {
      script.setAttribute('nonce', script.nonce);
    }
  });
});
